import './App.css';
import { LangProvider, useLang } from './LangContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Programs from './components/Programs';
import Gallery from './components/Gallery';
import Reviews from './components/Reviews';
import Contact from './components/Contact';
import Footer from './components/Footer';

function WhyStrip() {
  const { t } = useLang();
  return (
    <div className="why-strip">
      <h2>{t.whyTitle}</h2>
      <div className="why-grid">
        {t.whyItems.map((item) => (
          <div className="why-item" key={item.text}>
            <div className="why-icon">{item.icon}</div>
            <p>{item.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

function AppInner() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <About />
      <WhyStrip />
      <Programs />
      <Gallery />
      <Reviews />
      <Contact />
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <LangProvider>
      <AppInner />
    </LangProvider>
  );
}
